import React from 'react';
import { VbzModal, VbzButton } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

interface IModalRules {
  onClose?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  isOpen?: boolean;
}

const ModalRules: React.FC<IModalRules> = ({ onClose, isOpen }) => {
  const { t } = useTranslation('security_rules');

  const items: Array<string> = t('items', { returnObjects: true });

  return (
    <VbzModal className="vbz-modal-change-password" isOpen={isOpen} type="right" toggle={onClose}>
      <ModalBody>
        <h4>{t('title')}</h4>
        <ul>
          {items.map((item: string) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <VbzButton isLoading={false} text={t('got_it')} onClick={onClose} disabled={false} />
      </ModalBody>
    </VbzModal>
  );
};

export default ModalRules;
